import { AuthClient, CompanyClient, ContactClient, DocumentClient, EmailClient, PropertyClient, ServiceClient, UserClient } from '../api-client/api-client'
import { Store } from 'vuex'
import { State } from 'vue'
import { BaseApiClass } from './api-base';

export const getBaseApiUrl = () => {
	console.debug('Finding API URL for', window.location.host);

	// If a specific base api url is specified on the window object, use it.
	let apiUrl: string = window.baseApiUrl;
	if (apiUrl) {
		console.debug('URL specified on window.baseApiUrl');
	}

	// Default debug host, if not specified
	if (!apiUrl && (window.location.host == "localhost:8081" || window.location.host == "localhost:8080"))
		apiUrl = "https://localhost:7232";

	// Default prerelease API
	if (!apiUrl && window.location.host == "compass-prerelease.canary.nz")
		apiUrl = "https://compass-prerelease.canary.nz/api";

	// Default live API
	if (!apiUrl && window.location.host == "compass.canary.nz")
		apiUrl = "https://compass.canary.nz/api";

	// Default API via nginx
	if (!apiUrl && window.location.host.indexOf("canary.co.nz:50000") > 0)
		apiUrl = "https://" + window.location.host + "/compass/api";

	if (!apiUrl) {
		const error = `Note: could not determine api url to use.`;
		alert(error);
		console.error(error);
	}

	return apiUrl;
}

export abstract class CompassApi {

	static authApi(appStore: Store<State>) : AuthClient {
		const apiClient = new AuthClient(appStore.state.apiUrl);
		this.setTokenManagement(apiClient, appStore);
		return apiClient;
	}

	static companyApi(appStore: Store<State>) :CompanyClient {
		const apiClient = new CompanyClient(appStore.state.apiUrl);
		this.setTokenManagement(apiClient, appStore);
		return apiClient;
	}

	static contactApi(appStore: Store<State>): ContactClient {
		const apiClient = new ContactClient(appStore.state.apiUrl);
		this.setTokenManagement(apiClient, appStore);
		return apiClient;
	}

	static documentApi(appStore: Store<State>): DocumentClient {
		const apiClient = new DocumentClient(appStore.state.apiUrl);
		this.setTokenManagement(apiClient, appStore);
		return apiClient;
	}

	static emailApi(appStore: Store<State>): EmailClient {
		const apiClient = new EmailClient(appStore.state.apiUrl);
		this.setTokenManagement(apiClient, appStore);
		return apiClient;
	}

	static propertyApi(appStore: Store<State>): PropertyClient {
		const apiClient = new PropertyClient(appStore.state.apiUrl);
		this.setTokenManagement(apiClient, appStore);
		return apiClient;
	}

	static serviceApi(appStore: Store<State>): ServiceClient {
		const apiClient = new ServiceClient(appStore.state.apiUrl);
		this.setTokenManagement(apiClient, appStore);
		return apiClient;
	}

	static userApi(appStore: Store<State>): UserClient {
		const apiClient = new UserClient(appStore.state.apiUrl);
		this.setTokenManagement(apiClient, appStore);
		return apiClient;
	}

	private static setTokenManagement(apiClient: BaseApiClass, appStore: Store<State>) {
		apiClient.setTokenAndExpiryCallback(
			appStore.state.jwtToken,
			() => appStore.dispatch('tokenExpired'),
			() => appStore.dispatch('apiConnected')
		);
	}

	static translateError(mainMessage: string, error: any, consoleOutput: boolean): string {
		let message = "";

		if (mainMessage) {
			message += mainMessage;
			if (!message.endsWith('.')) message += ".";
			if (!message.endsWith(' ')) message += "  ";
		}

		if (error && error.status) {
			message += error.status;
			if (!message.endsWith('.')) message += ".";
			if (!message.endsWith(' ')) message += "  ";

		}

		if (error && error.message) {
			message += error.message;
			if (!message.endsWith('.')) message += ".";
			if (!message.endsWith(' ')) message += "  ";
		}

		if (error && error.response && error.response.title) {
			message += error.response.title;
			if (!message.endsWith('.')) message += ".";
			if (!message.endsWith(' ')) message += "  ";
		}

		if (error && error.response && error.response.detail) {
			message += error.response.detail;
			if (!message.endsWith('.')) message += ".";
			if (!message.endsWith(' ')) message += "  ";
		}

		if (error && error.response && error.response.errors) {
			let errorsArray = JSON.stringify(error.response.errors);
			errorsArray = errorsArray.replace(/({|\}|\[|\]|"|,)/g, " ");
			message += errorsArray;
		}

		if (consoleOutput) {
			console.error(message, JSON.stringify(error));
		}

		return message;
	}
}
